"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { CATEGORY_COMPONENTS } from './categoryContentMapping.mjs';

function ActiveCategoryContent({ onOptionSelect }) {
  const { activeCategory } = useComboBoxDropdownContext();
  const CategoryContainer = (activeCategory ? CATEGORY_COMPONENTS[activeCategory] : void 0) ?? (() => /* @__PURE__ */ jsx("p", { children: "Unknown category" }));
  return /* @__PURE__ */ jsx(CategoryContainer, { onOptionSelect });
}

export { ActiveCategoryContent };
